module.exports = __webpack_public_path__ + "2ad334fdd8073e1d70848f8e85c199cd.pdf";